import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { fouderList } from '../data/localData'
import { Link } from 'react-router-dom'

function FouderList() {
  return (
    <div className='fouder-list home-gap'>
      <Container>
        <h2 className='m-0 fs-48 fs-md-35 fs-sm-25 text-center fw-semibold list-title'>Meet Our Team</h2>
        <Row className='gy-4'>
          {
            fouderList.map((founder, index) => {
              return (
                <Col className='col-12 col-md-6' key={index}>
                  <div className='founder-item p-3 d-flex align-items-center gap-3 gap-sm-4'>
                    <div className="profile-holder">
                      <img src={founder.profileImage} alt="" />
                    </div>
                    <div className='d-grid gap-3 w-50'>
                      <div className='d-grid gap-1'>
                        <h5 className='fs-25 fs-md-20 fs-sm-16 m-0 fw-semibold m-0'>{founder.name}</h5>
                        <p className='fs-14 fs-md-12 fs-sm-10 m-0 fw-light m-0'>{founder.role}</p>
                      </div>
                      <div className='d-flex flex-wrap gap-2 gap-sm-3'>
                        {
                          founder.socialList.map((social, subIndex) => {
                            return (
                              <Link key={subIndex} className='social-links' to={social.value}>
                                  <i class={`bi bi-${social.label} fs-20 fs-md-16`}></i>
                              </Link>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                </Col>
              )
            })
          }
        </Row>
      </Container>
    </div>
  )
}

export default FouderList